import { NgModule } from '@angular/core';

import { SharedModule }                       from '../../shared/shared.module';
import { TableModule }                        from '../../table/table.module';
import { TransactionCenterBookingsComponent } from './transaction-center.bookings.component';
import { TransactionCenterBookingsService }   from './transaction-center.bookings.service';

@NgModule({
  declarations: [
    TransactionCenterBookingsComponent
  ],
  entryComponents: [
    TransactionCenterBookingsComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TransactionCenterBookingsService
  ]
})
export class TransactionCenterBookingsModule {}
